import script from "./series.vue?vue&type=script&setup=true&lang=js"
export * from "./series.vue?vue&type=script&setup=true&lang=js"

import "./series.vue?vue&type=style&index=0&id=359d4c2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359d4c2a"]])

export default __exports__